import { PropsWithChildren } from 'react';

export const SettingsControlShell = ({ children }: PropsWithChildren) => (
  <div className="w-fit h-8 cursor-pointer flex items-center gap-2 shrink-0 px-2 rounded-full bg-base-55 hover:bg-base-50 aria-expanded:bg-base-50">
    {children}
  </div>
);
